import React from 'react';
import { useParams } from 'react-router-dom';

function AddressWallet() {
  const { address } = useParams();

  // Now you can use the address in your component
  return (
    <div>
      <h2>Address Wallet</h2>
      <p>Address: {address}</p>
      {/* Other wallet information */}
    </div>
  );
}

export default AddressWallet;
